import { Box, Icon, Spinner } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'

import { useSwapShifts } from 'modules/shift_management/hooks/useSwapShifts'
import { trackOpenSwapRequestApproval } from 'modules/shift_management/lib/trackEvents'
import { useGetPlannedBreaks } from 'modules/time_planning/hooks/plannedBreaks/useGetPlannedBreaks'

import type { CollapseContentData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/SwapShiftRequests/types'
import EmployeeBlock from './EmployeeBlock'
import HeaderBlock from './HeaderBlock'
import ReasonBlock from './ReasonBlock'
import ShiftBlock from './ShiftBlock'
import ShiftDetailsBlock from './ShiftDetailsBlock'

interface Props {
  collapseContentData: CollapseContentData
}

const RightBlock = ({ collapseContentData }: Props) => {
  const {
    currentShiftAccessId,
    requestedShiftAccessId,
    currentShiftId,
    requestedShiftId,
    currentShiftRange,
    currentShiftTimeRange,
    requestedShiftRange,
    requestedShiftTimeRange,
    id,
    reason,
    currentShiftDefaultShiftTitle,
    currentShiftColor,
    requestedShiftDefaultShiftTitle,
    requestedShiftColor,
    currentShiftWorkAreaName,
    currentShiftNotes,
    currentShiftLocationName,
    currentShiftAddressLine1,
    currentShiftCity,
    requestedShiftWorkAreaName,
    requestedShiftNotes,
    requestedShiftLocationName,
    requestedShiftAddressLine1,
    requestedShiftCity,
  } = collapseContentData

  const shiftIds = [String(currentShiftId), String(requestedShiftId)]
  const { plannedBreaks } = useGetPlannedBreaks({
    variables: { shiftIds },
  })

  const swapShiftIds = id ? [String(id)] : []
  const { swapShiftsCollection, loading } = useSwapShifts({
    variables: { ids: swapShiftIds },
    skip: !swapShiftIds.length,
  })

  useEffect(() => {
    trackOpenSwapRequestApproval('Inbox')
  }, [])

  if (loading) {
    return <Spinner />
  }

  const swapShift = swapShiftsCollection.models[0]
  const teammateReason = swapShift?.teammateReason

  return (
    <>
      <Box flexDirection="column" width="full" gap="s24">
        <HeaderBlock />
        <Box flexDirection="column" width="full" gap="s12">
          <Box flexDirection="row" gap="s12" width="full">
            <EmployeeBlock accessId={currentShiftAccessId} />
            <Box width="s48"></Box>
            <EmployeeBlock accessId={requestedShiftAccessId} />
          </Box>

          <Box flexDirection="row" width="full" gap="s12">
            <ShiftBlock
              defaultShiftTitle={currentShiftDefaultShiftTitle}
              color={currentShiftColor}
              range={currentShiftRange}
              timeRange={currentShiftTimeRange}
            />

            <Box flexDirection="row" alignSelf="center">
              <Icon.Medium icon="replace" color="grey800" />
            </Box>

            <ShiftBlock
              defaultShiftTitle={requestedShiftDefaultShiftTitle}
              color={requestedShiftColor}
              range={requestedShiftRange}
              timeRange={requestedShiftTimeRange}
            />
          </Box>

          <Box flexDirection="row" gap="s16" width="full">
            <Box flexDirection="column" alignSelf="center" width="full" alignItems="center">
              <Icon.Small icon="arrow-down" color="grey800" />
            </Box>
            <Box width="s48"></Box>
            <Box flexDirection="column" alignSelf="center" width="full" alignItems="center">
              <Icon.Small icon="arrow-down" color="grey800" />
            </Box>
          </Box>

          <Box flexDirection="row" gap="s16" width="full">
            <ShiftDetailsBlock
              plannedBreaks={plannedBreaks}
              shiftId={String(currentShiftId)}
              workAreaName={currentShiftWorkAreaName}
              notes={currentShiftNotes}
              locationName={currentShiftLocationName}
              addressLine1={currentShiftAddressLine1}
              city={currentShiftCity}
            />
            <Box width="s48"></Box>
            <ShiftDetailsBlock
              plannedBreaks={plannedBreaks}
              shiftId={String(requestedShiftId)}
              workAreaName={requestedShiftWorkAreaName}
              notes={requestedShiftNotes}
              locationName={requestedShiftLocationName}
              addressLine1={requestedShiftAddressLine1}
              city={requestedShiftCity}
            />
          </Box>

          <Box flexDirection="row" gap="s16" width="full">
            <Box flexDirection="column" gap="s16" width="full">
              <ReasonBlock reason={reason} />
            </Box>
            <Box width="s48"></Box>
            <Box flexDirection="column" gap="s16" width="full">
              {teammateReason && <ReasonBlock reason={teammateReason} />}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default RightBlock
